import { FormDataGroup } from 'src/types';

export const leadsCitaVentaData: Partial<FormDataGroup> = {
  headers: { DESC_FORMOBJECTIVE: 'Cita' },
  fields: {
    formFields: { M_OBSERVATION_BRAND: 'Petición para reservar una cita en el concesionario.' },
    formularioFlag: 'prospect',
    formName: 'lead-cita',
    formType: 'contact',
    pageCategory: 'Cita',
  },
};

export const leadsCitaVentaDealerData: Partial<FormDataGroup> = {
  headers: { DESC_FORMOBJECTIVE: 'Cita' },
  fields: {
    formFields: { M_OBSERVATION_BRAND: 'Petición para reservar una cita en el concesionario.' },
    formularioFlag: 'prospect',
    formName: 'lead-cita-dealer',
    formType: 'contact',
    pageCategory: 'Cita',
  },
};
